module.exports = __webpack_public_path__ + "static/20-e3224377a9d28538b47627a16abb85dd.png";